import React from 'react';
import { Mail, MapPin, Clock, Instagram, Facebook } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';

export default function ContattiPage() {
  const { t } = useLang();

  return (
    <div data-testid="contatti-page" className="min-h-screen bg-[#FAF9F6] pt-24 pb-24">
      <section className="px-6 md:px-12 lg:px-24 py-16">
        <div className="max-w-4xl">
          <p className="overline mb-4">{t({ it: 'Contatti', en: 'Contact' })}</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter text-[#1C1917] mb-8">
            {t({ it: 'Siamo qui per te', en: 'We are here for you' })}
          </h1>
          <p className="text-lg text-[#1C1917]/70 leading-relaxed max-w-2xl mb-16">
            {t({
              it: 'Hai domande sui nostri capi, sul Club Biolosophy o su un ordine? Scrivici, ti risponderemo il prima possibile.',
              en: 'Questions about our garments, Club Biolosophy or an order? Write to us — we will get back to you as soon as possible.',
            })}
          </p>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white border border-[#E5E0D8] p-8" data-testid="contatti-email">
              <Mail className="w-7 h-7 text-[#4A5D23] mb-4" />
              <h2 className="font-medium text-[#1C1917] mb-2">Email</h2>
              <a href="mailto:info@biolosophy.it" className="text-sm text-[#4A5D23] hover:underline">
                info@biolosophy.it
              </a>
            </div>
            <div className="bg-white border border-[#E5E0D8] p-8" data-testid="contatti-sede">
              <MapPin className="w-7 h-7 text-[#4A5D23] mb-4" />
              <h2 className="font-medium text-[#1C1917] mb-2">{t({ it: 'Sede', en: 'Headquarters' })}</h2>
              <p className="text-sm text-[#1C1917]/70">Via Ofanto, 24<br />59100 Prato — Italy</p>
            </div>
            <div className="bg-white border border-[#E5E0D8] p-8" data-testid="contatti-orari">
              <Clock className="w-7 h-7 text-[#4A5D23] mb-4" />
              <h2 className="font-medium text-[#1C1917] mb-2">{t({ it: 'Assistenza', en: 'Support' })}</h2>
              <p className="text-sm text-[#1C1917]/70">{t({ it: 'Lun – Ven, 9:00 – 18:00', en: 'Mon – Fri, 9:00 – 18:00' })}</p>
            </div>
          </div>

          <div className="mt-16 flex items-center gap-6">
            <p className="text-sm text-[#57534E]">{t({ it: 'Seguici sui social:', en: 'Follow us:' })}</p>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-[#1C1917] hover:text-[#4A5D23] transition-colors">
              <Instagram className="w-5 h-5" />
            </a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-[#1C1917] hover:text-[#4A5D23] transition-colors">
              <Facebook className="w-5 h-5" />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
